"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FormMessage", {
  enumerable: true,
  get: function get() {
    return _FormMessage["default"];
  }
});
exports.FormFieldError = exports.FieldError = exports.InputsContainer = exports.VerticallyCenteredForm = exports.SubmitContainer = exports.CheckboxState = void 0;

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _polished = require("polished");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Input = require("../../../../../components/Ui/Form/Input");

var _motion = require("../../../../../style/motion");

var _FormMessage = _interopRequireDefault(require("../../../../../components/FormMessage"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;

var CheckboxState = _styledComponents["default"].div.withConfig({
  displayName: "Form__CheckboxState",
  componentId: "sc-1mk0d3p-0"
})(["", " transition-duration:0.1s;display:flex;align-items:center;justify-content:center;width:var(--checkboxStateSize);height:var(--checkboxStateSize);border-radius:5px;border:2px solid ", ";background-color:", ";&::after{", " transition-duration:0.1s;content:'';opacity:0;transform:scale(0);width:100%;height:100%;background-image:url('/images/icons/check-light.svg');background-repeat:no-repeat;background-position:center;background-size:12px 10px;}input:hover ~ &{background-color:", ";}input:focus{outline:none;}input:focus ~ &{box-shadow:0 0 0 2px var(--colors-blank),0 0 0 4px var(--colors-irisBlue);}input:checked ~ &{border-color:", ";background-color:", ";&::after{opacity:1;transform:scale(1);}}", ""], (0, _motion.sharedTransition)('border-color, background-color'), function (_ref) {
  var theme = _ref.theme;
  return theme.mode === 'light' ? (0, _polished.transparentize)('0.6', theme.colors.blank) : (0, _polished.transparentize)('0.4', theme.brandPrimary);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.mode === 'light' ? null : 'var(--colors-blank)';
}, (0, _motion.sharedTransition)('opacity, transform'), function (_ref3) {
  var theme = _ref3.theme;
  return theme.mode === 'light' ? (0, _polished.transparentize)('0.8', theme.colors.blank) : 'var(--brandPrimaryTransparentized)';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.mode === 'light' ? (0, _polished.transparentize)('0.4', theme.colors.blank) : "var(--brandPrimary)";
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.mode === 'light' ? null : "var(--brandPrimary)";
}, function (_ref6) {
  var $size = _ref6.$size;

  switch ($size) {
    case 'small':
      {
        return (0, _styledComponents.css)(["--checkboxStateSize:16px;border-width:1.5px;border-radius:3px;&::after{background-size:8px 6px;}"]);
      }

    default:
      return null;
  }
});

exports.CheckboxState = CheckboxState;

var SubmitContainer = _styledComponents["default"].div.withConfig({
  displayName: "Form__SubmitContainer",
  componentId: "sc-1mk0d3p-1"
})(["--spacingTop:50px;display:flex;flex-direction:column;align-items:center;margin-top:var(--spacingTop);text-align:center;@media screen and (min-width:", "){--spacingTop:100px;}@media screen and (min-width:", "){--spacingTop:150px;}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.screenMedium;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.screenLarge;
});

exports.SubmitContainer = SubmitContainer;

var VerticallyCenteredForm = _styledComponents["default"].form.withConfig({
  displayName: "Form__VerticallyCenteredForm",
  componentId: "sc-1mk0d3p-2"
})(["flex-grow:1;flex-shrink:0;display:flex;flex-direction:column;", "{margin:0;}"], SubmitContainer);

exports.VerticallyCenteredForm = VerticallyCenteredForm;

var InputsContainer = _styledComponents["default"].div.withConfig({
  displayName: "Form__InputsContainer",
  componentId: "sc-1mk0d3p-3"
})(["margin:var(--dynamicFormContainerMargin,45px 0 80px);flex-grow:1;display:flex;flex-direction:column;justify-content:center;"]);

exports.InputsContainer = InputsContainer;

var FieldError = _styledComponents["default"].div.withConfig({
  displayName: "Form__FieldError",
  componentId: "sc-1mk0d3p-4"
})(["font-size:13px;line-height:1.2;color:var(--colors-redPink);opacity:1;text-align:", ";white-space:initial;", "{display:inline;}"], function (props) {
  return props.textCenter ? 'center' : 'inherit';
}, _Input.LabelText);

exports.FieldError = FieldError;
var InvisibleFieldError = (0, _styledComponents["default"])(FieldError).withConfig({
  displayName: "Form__InvisibleFieldError",
  componentId: "sc-1mk0d3p-5"
})(["visibility:hidden;"]);
/**
 * FormFieldError
 *
 * This component renders an error message if a field has
 * an error and it's already been touched.
 *
 * preventJump - Endures a similar component is rendered in place
 * so when it appears, the form elements dont jump
 */

var FormFieldError = (0, _formik.connect)(function (_ref9) {
  var name = _ref9.name,
      formik = _ref9.formik,
      preventJump = _ref9.preventJump,
      textCenter = _ref9.textCenter,
      description = _ref9.description,
      className = _ref9.className;
  var error = (0, _formik.getIn)(formik.errors, name);
  var touch = (0, _formik.getIn)(formik.touched, name);
  var noErrorOutput = preventJump ? __jsx(InvisibleFieldError, null, "\xA0") : null;
  return touch && error ? __jsx(FieldError, {
    textCenter: textCenter,
    className: className
  }, error, ' ', description && __jsx(_Input.LabelText, null, '- ', " ", description)) : noErrorOutput;
});
exports.FormFieldError = FormFieldError;